import { useEffect, useRef } from 'react'
import { useSearchParams } from 'react-router'
import { toast } from 'sonner'

const OAUTH_ERROR_MESSAGES: Record<string, string> = {
  state_mismatch: 'Your sign-in session expired. Please try again.',
  please_restart_the_process:
    'Something interrupted sign-in. Please try again.',
  access_denied: 'Sign-in was cancelled.',
  "email_doesn't_match":
    'That Google account uses a different email. Sign in to Google with your account email.',
  account_already_linked_to_different_user:
    'That Google account is already connected to another account.',
  account_not_linked:
    'We couldn’t sign you in with Google. Click “Forgot password?” to set a password for this email, then try again.',
  unable_to_link_account:
    'Could not connect your Google account. Please try again.',
  ACCOUNT_DEACTIVATED:
    'This account has been deactivated. Contact support@tandemone.net if you think this is a mistake.'
}

export function useOAuthError(): void {
  const [searchParams, setSearchParams] = useSearchParams()
  const shown = useRef(false)
  const errorCode = searchParams.get('error')
  const message: string | undefined = errorCode
    ? OAUTH_ERROR_MESSAGES[errorCode]
    : undefined

  useEffect(() => {
    if (!message || shown.current) return
    shown.current = true
    toast.error(message)
    const next = new URLSearchParams(searchParams)
    next.delete('error')
    next.delete('error_description')
    setSearchParams(next, { replace: true })
  }, [message, searchParams, setSearchParams])

  if (errorCode && !message) {
    throw new Error(`Unexpected OAuth error: ${errorCode}`)
  }
}
